module.exports = __webpack_public_path__ + "img/37_148.87ecf950.png";